import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './auth';

//authenticating data token in auth and session & allowing only valid user
export const RequireAuth = ({ children }) => {
  const location = useLocation();
  const auth = useAuth();

  if (!auth?.user && sessionStorage.getItem('user') === null) {
    return <Navigate to="/login" state={{ path: location.pathname }} />;
  }
  return children;
};
